import { Response, Settings } from "@version2/domain-package";
import { apiPost, apiPatch, apiDelete, apiGet } from "./client";

/**
 * Create a new user integration
 */
export const createUserIntegration = async (
	integrationId: string
): Promise<Response> => {
	try {
		const response = await apiPost("/v1/integrations", {
			integration_id: integrationId,
		});
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

/**
 * Delete a user integration
 */
export const deleteUserIntegration = async (
	userIntegrationId: string
): Promise<Response> => {
	try {
		const response = await apiDelete(`/v1/integrations/${userIntegrationId}`, {});
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

/**
 * Update user integration settings
 */
export const updateUserIntegrationSettings = async (
	userIntegrationId: string,
	settings: Settings[]
): Promise<Response> => {
	try {
		const response = await apiPatch(`/v1/integrations/${userIntegrationId}`, {
			settings: settings.map((setting) => setting.toJson()),
		});
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

/**
 * Test a user integration connection
 */
export const testUserIntegration = async (
	userIntegrationId: string
): Promise<Response> => {
	try {
		const response = await apiPost(`/v1/integrations/${userIntegrationId}/test`, {});
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

/**
 * Fetch data from an integration
 */
export const fetchIntegrationData = async (
	payload: Record<string, unknown>
): Promise<Response> => {
	try {
		const response = await apiPost("/v1/integrations/data", payload);
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

/**
 * Get ClickConnector user hash for secure widget identification
 */
export const getClickConnectorUserHash = async (): Promise<Response> => {
	try {
		const response = await apiGet("/v1/integrations/clickconnector/user-hash");
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

/**
 * Get all user integrations for the current user
 */
export const getUserIntegrations = async (): Promise<Response> => {
	try {
		const response = await apiGet("/v1/integrations");
		if (!response.success) {
			throw response;
		}
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};
